module.exports = "/_next/static/images/ace627336b4f153fd47961c72decd3e1-pj-woman-working@3x.jpg.webp";